import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import request from "../../../../Helpers/API";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { ModalAgregarNotificacion } from "./ModalAgregarNotificacion";
import { ModalNotificacionesDetalle } from "./ModalNotificacionesDetalle";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import FiltroNotificaciones from "./FiltroNotificaciones";
import { useBox } from "../../../Finanzas/Helper/useBox";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";

export const ConfNotificacionesMainScreen = () => {
  const history = useHistory();
  const [listaNotificaciones, setListaNotificaciones] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [edita, setEdita] = useState(false);
  const [openModalDetalle, setOpenModalDetalle] = useState(false);
  const [idencabezado, setIdencabezado] = useState(-99);
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() ;
  // const currentMonthPadded = String(currentMonth).padStart(2, '0');
  const fechaInicio = new Date(currentYear, currentMonth, 1) // `${currentYear}-${currentMonthPadded}-01`)
    .toISOString()
    .split("T")[0];
  const fechaFin = today.toISOString().split("T")[0];
  // const fechaFin = new Date(currentYear, currentMonth + 1, 0)
  // .toISOString()
  // .split("T")[0];


  const initialStateboxfiltros = () => {
    return {
      fecha_inicio: fechaInicio,
      fecha_fin: fechaFin,
      pv: {
        departamento: [],
      },
      tipo: [],
    };
  };
  const [boxstate, setBoxState] = useBox(initialStateboxfiltros);

  // console.log(boxstate)
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    onExecute(boxstate.fecha_inicio, boxstate.fecha_fin);
  }, []);

  const onExecute = (fechainicio, fechafin) => {
    var departamento = GetKey(boxstate.pv.departamento, ["iddepartamento"]);
    if (
      departamento === undefined ||
      departamento === null ||
      departamento === ""
    ) {
      departamento = "";
    }
    if (
      boxstate.tipo === undefined ||
      boxstate.tipo === null ||
      boxstate.tipo === ""
    ) {
      boxstate.tipo = "";
    }

    if (
      fechainicio === undefined ||
      fechainicio === null ||
      fechainicio === ""
    ) {
      fechainicio = boxstate.fecha_inicio;
    }

    if (fechafin === undefined || fechafin === null || fechafin === "") {
      fechafin = boxstate.fecha_fin;
    }

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `ProgramarNotificacion/ListadoFiltrado`,
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setListaNotificaciones(result);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          JSON.stringify(
            "PERMISOS",
            "Error al obtener las notificaciones",
            "error",
          );
          return;
        });
    });
  };

  // console.log(listaNotificaciones)
  const onAbrirModal = (idencabezado, esEditar) => {
    setIdencabezado(idencabezado);
    setEdita(esEditar);
    setOpenModal(true);
  };

  const onAbrirModalDetalle = (idencabezado) => {
    setIdencabezado(idencabezado);
    setOpenModalDetalle(true);
  };

  const onCerrarModal = () => {
    setOpenModal(false);
  };
  const onCerrarModalDetalle = () => {
    setOpenModalDetalle(false);
  };

  const onEstatus = (estatus) => {
    if (estatus === 1) {
      return "info-estatus-circulo circulo-verde";
    } else if (estatus === "A") {
      return "info-estatus-circulo circulo-amarillo";
    } else if (estatus === 0) {
      return "info-estatus-circulo circulo-amarillo";
    }
  };

  const onCambioEstado = async (idcambio, estado) => {
    const nuevoEstado = estado === true ? "Deshabilitado" : "Activado";
    const mensajeEstado =
      estado === true
        ? "La notificación se desactivara"
        : "Se activara la notificación";

    const preguntaEstado =
      estado === true
        ? "¿Esta seguro que quiere Desactivarla?"
        : "¿Esta seguro que quiere Activarla?";
    const confirmacion = await Swal.fire({
      title: preguntaEstado,
      text: mensajeEstado,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, Cambiar",
      cancelButtonText: "Cancelar",
    });

    if (!confirmacion.isConfirmed) return;
    try {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`ProgramarNotificacion/cambiar_estado?idencabezado=${idcambio}`)
        .then(() => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire(
            "Éxito",
            `El estatus ha sido cambiado a '${nuevoEstado}'`,
            "success",
          );
          onExecute();
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Error", JSON.stringify(error), "error");
        });
    } catch (error) {
      Swal.fire("Error", "No se pudo realizar el cambio de estatus", "error");
      return;
    }
  };
  return (
    <PlantillaScreen
      titulo={`NOTIFICACIONES PENDIENTES`}
      className_main={1}
      className={"permisos-usuarios-main-screen"}
    >
      {openModal === true && (
        <ModalAgregarNotificacion
          idencabezado={idencabezado}
          open={openModal}
          esEditar={edita}
          handleClose={onCerrarModal}
          ObtenerListado={onExecute}
        />
      )}

      {openModalDetalle === true && (
        <ModalNotificacionesDetalle
          idencabezado={idencabezado}
          open={openModalDetalle}
          handleClose={onCerrarModalDetalle}
          ObtenerListado={onExecute}
        />
      )}
      <LoaderScreen loader={loader} />

      <div className="configuracion-notificaciones-main-screen-container">
        <div className="listado-precios-botones-pagina-container">
          <div
            className="listado-precios-actions-regresar"
            onClick={() => history.push("/Permisos/Main")}
          >
            <ArrowBackIcon />
            Regresar
          </div>

          {/* <div className="notificaciones-actions-filtro">
            <FiltroNotificaciones
              onExecute={onExecute}
              boxState={boxstate}
              onBoxChange={setBoxState}
            />
          </div> */}
        </div>

        <div className="configuracion-notificaciones-botones-container">
          <button
            className="configuracion-notificaciones-boton-agregar"
            onClick={() => onAbrirModal(-99, false)}
          >
            <AddCircleOutlineIcon />
            Agregar
          </button>
        </div>
        <div className="configuracion-notificaciones-tabla-container scroll">
          <table cellSpacing={0} cellPadding={0}>
            <thead>
              <tr>
                <th></th>
                <th>Mensaje</th>
                <th>
                  <div>Departamento</div>
                </th>
                <th>
                  <div>Fecha inicio</div>
                </th>
                <th>
                  <div>Fecha fin</div>
                </th>
                <th>
                  <div>Hora</div>
                </th>
                <th>
                  <div>Redirección</div>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {/* Sección: Programadas */}
              {listaNotificaciones.some(
                (n) => n.tipo_alerta !== "RA" && n.tipo_alerta !== "IN",
              ) && (
                <>
                  <tr>
                    <td
                      colSpan={11}
                      className="configuracion-notificaciones-tabla-titulos"
                    >
                      <div className="configuracion-notificaciones-titulo-contenido">
                        <AccessTimeIcon />
                        <span>Programadas</span>
                      </div>
                    </td>
                  </tr>

                  {listaNotificaciones
                    .filter(
                      (n) => n.tipo_alerta !== "RA" && n.tipo_alerta !== "IN",
                    )
                    .map((lst) => (
                      <tr key={lst.idencabezado}>
                        <td className="celda-circulo celda-fija">
                          <div
                            className={onEstatus(lst.pausado)}
                            onClick={() =>
                              onCambioEstado(lst.idencabezado, lst.estatus)
                            }
                          ></div>
                        </td>
                        <td className="celda-mensaje">{lst.mensaje}</td>
                        <td>{capitalizePalabras(lst.departamento)}</td>
                        <td className="celda-fecha">{lst.fecha_inicio}</td>
                        <td className="celda-fecha">{lst.fecha_fin}</td>
                        <td className="celda-hora">{lst.hora}</td>
                        <td className="celda-redireccion">{lst.modulo}</td>
                        <td>
                          <div className="configuracion-notificaciones-tabla-botones-container">
                            <button
                              className="configuracion-notificaciones-tabla-boton-editar"
                              onClick={() =>
                                onAbrirModal(
                                  lst.idencabezado,
                                  true,
                                  lst.estatus,
                                )
                              }
                            >
                              <EditIcon /> Editar
                            </button>
                            <button
                              className="configuracion-notificaciones-tabla-boton-detalle"
                              onClick={() =>
                                onAbrirModalDetalle(lst.idencabezado)
                              }
                            >
                              <VisibilityIcon /> Detalle
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </>
              )}

              {/* Sección: Realizar acción */}
              {listaNotificaciones.some((n) => n.tipo_alerta === "RA") && (
                <>
                  <tr>
                    <td
                      colSpan={11}
                      className="configuracion-notificaciones-tabla-titulos"
                    >
                      <div className="configuracion-notificaciones-titulo-contenido">
                        <TouchAppIcon />
                        <span>Realizar Acción</span>
                      </div>
                    </td>
                  </tr>

                  {listaNotificaciones
                    .filter((n) => n.tipo_alerta === "RA")
                    .map((lst) => (
                      <tr key={lst.idencabezado}>
                        <td className="celda-circulo celda-fija">
                          <div
                            className={onEstatus(lst.pausado)}
                            onClick={() =>
                              onCambioEstado(lst.idencabezado, lst.estatus)
                            }
                          ></div>
                        </td>
                        <td className="celda-mensaje">{lst.mensaje}</td>
                        <td>{lst.departamento}</td>
                        <td className="celda-fecha">{lst.fecha_inicio}</td>
                        <td className="celda-fecha">{lst.fecha_fin}</td>
                        <td className="celda-hora">{lst.hora}</td>
                        <td className="celda-redireccion">{lst.modulo}</td>
                        <td>
                          <div className="configuracion-notificaciones-tabla-botones-container">
                            {/* botones si aplica */}
                          </div>
                        </td>
                      </tr>
                    ))}
                </>
              )}

              {/* Sección: Instantaneas */}
              {listaNotificaciones.some((n) => n.tipo_alerta === "IN") && (
                <>
                  <tr>
                    <td
                      colSpan={11}
                      className="configuracion-notificaciones-tabla-titulos"
                    >
                      <div className="configuracion-notificaciones-titulo-contenido">
                        <HistoryToggleOffIcon />
                        <span>Instantánea</span>
                      </div>
                    </td>
                  </tr>

                  {listaNotificaciones
                    .filter((n) => n.tipo_alerta === "IN")
                    .map((lst) => (
                      <tr key={lst.idencabezado}>
                        <td className="celda-circulo celda-fija">
                          <div
                            className={onEstatus(lst.pausado)}
                            onClick={() =>
                              onCambioEstado(lst.idencabezado, lst.estatus)
                            }
                          ></div>
                        </td>
                        <td className="celda-mensaje">{lst.mensaje}</td>
                        <td>{capitalizePalabras(lst.departamento)}</td>
                        <td className="celda-fecha">{lst.fecha_inicio}</td>
                        <td className="celda-fecha">{lst.fecha_fin}</td>
                        <td className="celda-hora">{lst.hora}</td>
                        <td className="celda-redireccion">{lst.modulo}</td>
                        <td>
                          <div className="configuracion-notificaciones-tabla-botones-container">
                            {/* botones si aplica */}
                          </div>
                        </td>
                      </tr>
                    ))}
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </PlantillaScreen>
  );
};
